export { CustomMarker3 as default } from "./CustomMarker3";
